// MDM Forge changelog. Add a new entry to the TOP of this array each time you ship.
// type: "new" | "improved" | "fixed"
export const CHANGELOG = [
  {
    version: "1.5.0",
    date: "2026-06-24",
    title: "Ask AI on every tool + a premium refresh",
    changes: [
      { type: "new", text: "Every Deploy Software tool now has an 'Ask AI' panel — describe what you want and AI fills the fields, or 'Fill & generate' to build it in one step." },
      { type: "improved", text: "Premium visual refresh: refined IBM Plex Sans / Inter / JetBrains Mono typography and a subtle animated AI accent, keeping the dark technical feel." },
    ],
  },
  {
    version: "1.4.0",
    date: "2026-06-24",
    title: "Smarter printers & AI you can trust",
    changes: [
      { type: "new", text: "Printer Automation: describe a printer in plain English and let AI fill in the protocol, driver mode, address and options." },
      { type: "new", text: "Printer Automation: download a self-contained offline package with the vendor driver .pkg baked in — installs with zero internet." },
      { type: "new", text: "Custom Software: the AI now explains what each generated pre/post-install step does before you deploy fleet-wide." },
      { type: "improved", text: "Generated scripts now open with a clearly-delimited VARIABLES block — every value you need to edit lives in one place (printers, custom software, all tool installers, and AI-generated scripts)." },
      { type: "improved", text: "Printer Automation: live lpadmin command preview and validation warnings as you build each queue." },
      { type: "improved", text: "Custom Software: added a goal field so you can tell the AI exactly what outcome you want." },
    ],
  },
  {
    version: "1.3.0",
    date: "2026-06-20",
    title: "Knowledge Base, fully documented",
    changes: [
      { type: "new", text: "Knowledge Base now covers every feature step-by-step — including Custom Software, ForgePkg, AutoPkg Autopilot and Admin." },
      { type: "new", text: "New-Mac Onboarding bundle: stitch multiple tools into one ordered, zero-touch export." },
      { type: "improved", text: "Deep, full-fidelity builders for Support App, swiftDialog, Nudge, super, Setup Your Mac and more." },
      { type: "fixed", text: "Support App logo handling now references remote URLs directly (no fragile install-time download)." },
    ],
  },
  {
    version: "1.2.0",
    date: "2026-06-14",
    title: "True plug-and-play packages",
    changes: [
      { type: "new", text: "Hosted Package Library: MDM Forge hosts app binaries on its own storage so builds don't depend on vendor uptime." },
      { type: "new", text: "Self-contained offline ZIPs with baked configuration and an offline install.sh." },
      { type: "improved", text: "ForgePkg resolves the latest vendor release and verifies the Apple Team ID." },
    ],
  },
];

export const LATEST_VERSION = CHANGELOG[0].version;
export const SEEN_KEY = "mdmforge_seen_version";
